import styles from "./ForgotPassword.module.scss";
import FrameBack from "images/frame_back.svg?react";
import MainLogo from "images/main-logo.svg?react";
import Email from "images/email-forgot.svg?react";
import { TextField } from "@material-ui/core";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ChangeEvent, FocusEvent, useEffect, useState } from "react";
import { getErrorComponents } from "../../services/util";
import useSignInForm from "./utils";
import TalaeraSpinner from "../../components/TalaeraSpinner/TalaeraSpinner";
import { routes } from "pages/routes";
import { forgotPassword } from "../../services/users/auth";
import { useTranslation } from "react-i18next";
import assert from "utils/assert";
import { useDocumentTitle } from "utils/useDocumentTitle";

function ForgotPassword() {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    account,
    setAccount,
    errors: formErrors,
    touched,
    setTouched,
    onValidate,
    onTouched,
  } = useSignInForm({ email: "" });
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState("");
  const [resetDone, setResetDone] = useState(false);

  useDocumentTitle(
    t("ForgotPassword.pageTitle"),
    "This page is for registered user to reset their password"
  );

  const handleChangeField = (e: ChangeEvent<HTMLInputElement>) => {
    if (resetDone) {
      setResetDone(false);
    }
    setAccount({ ...account, [e.target.name]: e.target.value });
  };

  const handleBlurField = (e: FocusEvent<HTMLInputElement>) => {
    onTouched(e.target.name);
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    const isValidated = onValidate();
    setTouched({
      email: true,
    });

    if (isValidated) {
      setErrors("");
      setLoading(true);
      assert(account.email, "Email is required");
      try {
        await forgotPassword({ email: account.email });
        // _this.props.showToast && _this.props.showToast(TOAST_MESSAGE);
        setResetDone(true);
      } catch (error: any) {
        setErrors(error);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (location && location?.state?.error) {
      setErrors(location?.state?.error);
      navigate(location.pathname, { state: null, replace: true });
    }
    // eslint-disable-next-line
  }, [location]);

  return (
    <div className={styles.page}>
      <div className={styles.content}>
        <MainLogo />

        {errors && <div className={styles.error}>{getErrorComponents(errors)}</div>}

        {!resetDone && (
          <>
            <div className={styles.header}>
              <h1>{t("ForgotPassword.resetYourPassword")}</h1>
            </div>

            <div className={styles.description}>
              {t("ForgotPassword.resetYourPasswordText")}
            </div>

            <form onSubmit={handleSubmit}>
              <div className={styles.formWrapper}>
                <TextField
                  name="email"
                  label={t("ForgotPassword.Email address")}
                  placeholder="johnsmith@gmail.com"
                  variant="outlined"
                  value={account.email}
                  error={!!(formErrors.email && touched.email)}
                  helperText={touched.email && formErrors.email}
                  onChange={handleChangeField}
                  onBlur={handleBlurField}
                />

                {loading ? (
                  <div className={styles.spinner}>
                    <TalaeraSpinner />
                  </div>
                ) : (
                  <button className={`btn ${styles.button}`} type="submit">
                    {t("ForgotPassword.resetYourPasswordContinue")}
                  </button>
                )}
              </div>
            </form>
          </>
        )}

        {resetDone && (
          <div className={styles.resetSentContainer}>
            <Email />

            <h1 className={styles.resetTitle}>{t("ForgotPassword.checkYourEmail")}</h1>

            <p className={styles.resetMessage}>
              {t("ForgotPassword.checkYourEmailText")}
            </p>

            <button className={styles.resendButton}>
              {t("ForgotPassword.resendEmail")}
            </button>
          </div>
        )}
      </div>

      <div>
        <Link className={styles.link} to={routes.public.signIn.path()}>
          ← {t("ForgotPassword.Back to Login")}
        </Link>
      </div>

      <FrameBack className={styles.frameBack} />
    </div>
  );
}

export default ForgotPassword;
